import React, {Component, PropTypes} from 'react';
import {
  Modal,
  Button,
  Table,
  Icon,
  FormControl,
  FormGroup,
  ControlLabel,
} from '@sketchpixy/rubix';

import {copyAssets} from '../api/api';
import SelectTypeModal from './SelectTypeModal';

const OVERWRITE = 'overwrite';
const DELETE_AND_PUSH = 'deleteAndPush';

class CopyModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTypeModal: false,
      selectedAssetVersionId: null,
      versions: [],
    };
  }

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.versions !== nextProps.versions) {
      let versions = [];
      nextProps.versions.map(version => {
        if (version.version !== nextProps.currentVersion) {
          versions.push(version)
        }
      });

      this.setState({
        versions,
        selectedAssetVersionId: versions[0].assetVersionId,
      });
    }
  }

  showTypeModal() {
    this.setState({showTypeModal: true});
  }

  hideTypeModal = () => {
    this.setState({showTypeModal: false});
  };

  hide = () => {
    this.props.hideModal();
  };

  overwrite = (selectedAssetVersionId, cb) => {
    copyAssets(selectedAssetVersionId, this.props.currentAssetVersionId, OVERWRITE, cb);
  };

  deleteAndPush = (selectedAssetVersionId, cb) => {
    copyAssets(selectedAssetVersionId, this.props.currentAssetVersionId, DELETE_AND_PUSH, cb);
  };

  versionChangeHandler = (e) => {
    let selectedAssetVersionId = parseInt(e.currentTarget.value);
    this.setState({
      selectedAssetVersionId,
    });
  };

  copyButtonHandler = () => {
    let selectedAssetVersionId = this.state.selectedAssetVersionId;
    if (selectedAssetVersionId === null) {
      selectedAssetVersionId = this.state.versions[0].assetVersionId;
      this.setState({
        selectedAssetVersionId,
      });
    }

    if (this.props.existAssets) {
      this.hide();
      this.showTypeModal();
    } else {
      this.overwrite(selectedAssetVersionId, (err, result) => {
        if (err) {
          Messenger().post({
            type: 'error',
            message: 'Error while copying. please try later.',
            showCloseButton: true,
          });

          this.props.copyFilesCallback();
        } else {
          Messenger().post({
            type: 'success',
            message: 'files copied successfully!',
            showCloseButton: true,
          });

          this.props.copyFilesCallback();
        }
      });
    }
  };

  render() {
    return (
        <div>
          <Modal show={this.props.showCopyModal} onHide={this.hide}>
            <Modal.Header closeButton>
              <Modal.Title>Copy assets</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table striped>
                <thead>
                <tr>
                  <th>From</th>
                  <th />
                  <th>To</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <FormGroup controlId="formControlsSelect">
                      <ControlLabel>Select the asset version code</ControlLabel>
                      <FormControl componentClass="select" placeholder="select" onChange={this.versionChangeHandler}>
                        {
                          this.state.versions.map(version => (
                              <option value={version.assetVersionId} key={version.version}>
                                {version.version}
                              </option>
                          ))
                        }
                      </FormControl>
                    </FormGroup>
                  </td>
                  <td style={{textAlign: 'center', paddingTop: '18px'}}>
                    <Icon glyph="icon-fontello-right-bold icon-2x" className="fg-desaturateddarkblue" />
                  </td>
                  <td>
                    <FormGroup controlId="formBasicText">
                      <ControlLabel>Target asset version code</ControlLabel>
                      <FormControl
                          type="text"
                          value={this.props.currentVersion}
                          disabled
                      />
                    </FormGroup>
                  </td>
                </tr>
                </tbody>
              </Table>
             </Modal.Body>
            <Modal.Footer>
              <Button bsStyle="brownishgray" onClick={this.hide}>Cancel</Button>
              <Button bsStyle="brownishgray" onClick={this.copyButtonHandler}>Copy</Button>
            </Modal.Footer>
          </Modal>
          {this.state.selectedAssetVersionId &&
              <SelectTypeModal
              showModal={this.state.showTypeModal}
              hideModal={this.hideTypeModal}
              selectedAssetVersionId={this.state.selectedAssetVersionId}
              overwrite={this.overwrite}
              deleteAndPush={this.deleteAndPush}
              currentVersionCode={this.props.currentVersion}
              copyFilesCallback={this.props.copyFilesCallback}
             />
          }
        </div>
    );
  }
}

CopyModal.propTypes = {
  showCopyModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  versions: PropTypes.array.isRequired,
  currentVersion: PropTypes.number.isRequired,
  currentAssetVersionId: PropTypes.number.isRequired,
  existAssets: PropTypes.bool.isRequired,
  copyFilesCallback: PropTypes.func.isRequired,
};

export default CopyModal;



// WEBPACK FOOTER //
// ./src/component/CopyModal.js